<mat-horizontal-stepper linear #stepper (animationDone)="this.ajustarImagen('completeKudo')" style="padding:0">

  <mat-step [editable]="isEditable">


    <ng-template matStepLabel>Elige tu Kudo</ng-template>
    <div>
 
      <div fxLayout="row" fxLayoutAlign="center center" [ngStyle]="{  
        'display': 'none'
        }">
        
        <mat-form-field fxLayout="column wrap"  center start>
          <mat-label class="textWhite">Descubre los tipos de kudo</mat-label>
          <input type="text" matInput  [(ngModel)]="filterTerm">
        </mat-form-field>
       
      </div>
    
      <div fxLayout="row wrap" fxLayoutAlign="center start">

        <button *ngFor="let item of images | filter:filterTerm"  class="card-kudo colorWhite" mat-button matStepperNext
          (click)="selectKudo(item);">
     <!--   -->
        <img src="{{this.item.url}}" style="max-width: 200px;max-height: 200px;" matStepperNext> 
        </button>
      </div>
    </div>

  </mat-step>
  <mat-step [editable]="isEditable">

    <ng-template matStepLabel>Completa tu kudo</ng-template>
    <div fxLayoutAlign="center">
      <div style="height: 300px;width: 40px;" fxLayoutAlign="center center">
        <button mat-button matStepperPrevious>
          <mat-icon class="botonFlecha" aria-hidden="false" style="color: green" matStepperPrevious>arrow_back_ios_new
          </mat-icon>
        </button>

      </div>
      <div id="completeKudo" [style.background-image]="'url(' + this.selectedKudoUrl.url + ')'" [ngStyle]="{  
                    'width': '400px',
                    'height': '300px'
                    }">
        <textarea matInput [ngStyle]="{  
                    'font-family': 'cursive',
                    'z-index': 5,
                    'width': this.selectedKudoUrl.orientationText === 'left' ? '44%' : '54%',
                    'height': '-webkit-fill-available',
                    'line-height': '17pt',
                    'resize': 'none',
                    'overflow-y': 'hidden',
                    'padding-top': '107px',
                    'padding-left':this.selectedKudoUrl.orientationText === 'left' ? '50px' : '0px',
                    'float': '' + this.selectedKudoUrl.orientationText+ ''
                    }
        "></textarea>
      </div>

      <div style="height: 300px;width: 40px;margin:3px;" fxLayout="column" fxLayoutAlign="center">

        <button style="padding-left: 0;margin-left: -12px;" mat-button
          (click)="this.generatePreviewPng('completeKudo','shareKudo')" matStepperNext>
          <mat-icon class="botonFlecha" aria-hidden="false">arrow_forward_ios</mat-icon>
        </button>
      </div>
    </div>
  </mat-step>
  <mat-step [editable]="isEditable">
    <ng-template matStepLabel>Compartelo</ng-template>
    <div fxLayoutAlign="center">
      <div style="height: 300px;width: 40px;" fxLayoutAlign="center center">
        <button mat-button matStepperPrevious>
          <mat-icon class="botonFlecha" aria-hidden="false" style="color: green" matStepperPrevious>arrow_back_ios_new
          </mat-icon>
        </button>

      </div>
      <div id="contentDownload" style="
                    height: 200px !important;
                    width: 400px;
                    display: block;
                    position: relative;
                    line-height: 0;
                    font-size: 0;
                    overflow: hidden;
                    display: none;">
        <img id="shareKudo">
      </div>
      <div id="Finish" style="
height: 300px !important;
    width: 292px;
                    display: block;
                    line-height: 0;
                    font-size: 0;
                    position: relative;
                    background-color: white;
                    ">
        <img id="compartirRedes" src="{{this.compartirRedes}}" style="
width: 152px;
    height: 134px;
              float: right;
              background-size :100% 100%;
              margin-right: 3px;
    margin-top: 38px;
                   -moz-transform: rotate(-10deg);
     -o-transform: rotate(-10deg);
     -webkit-transform: rotate(-10deg);
     transform: rotate(-10deg);
              ">
        <img id="avatarBrian" src="{{this.avatarBrian}}" (click)="downloadAsPng('contentDownload')" style="
width: 227px;
    height: 154px !important;
                          float:left;
                          background-size : 100% 100%;
                          position: absolute;
                          bottom: 1px;
                          margin-left: 25px;
                          ">
      </div>

      <div style="    height: 300px !important;
    width:  86px;
    background-color: white;" fxLayout="column" fxLayoutAlign="center start">
        <button style="margin:3px" mat-button (click)="downloadAsPng('contentDownload')">
          <mat-icon class="botonFlechaRight" aria-hidden="false">cloud_download</mat-icon>
        </button>
        <button style="margin:3px;display: none;" mat-button (click)="downloadAsPng('contentDownload')">
          <mat-icon class="botonFlechaRight" aria-hidden="false">facebook</mat-icon>
        </button>
        <button style="margin:3px;display: none;" mat-button (click)="downloadAsPng('contentDownload')">
          <mat-icon class="botonFlechaRight" aria-hidden="false">content_copy</mat-icon>
        </button>
      </div>
    </div>
  </mat-step>

</mat-horizontal-stepper>